import Home from "./Component/Home"

const HomePage = () => {
  return (
    <Home />
  )
}

export default HomePage